export const LoadingSection = () => ({
  zIndex: 20,
});

export const BackdropSection = () => ({
  zIndex: 20,
});